export const theme = {
  colors: {
    // Primary orangish colors inspired by the branding
    primary: '#ff8c42', // Warm orange - main brand color
    secondary: '#ffb366', // Lighter orange for secondary elements
    accent: '#ff6b35', // Vibrant orange accent
    
    // Text colors for light theme
    text: {
      primary: 'var(--text-primary)', // Dynamic text color
      secondary: 'var(--text-secondary)', // Dynamic secondary text
      light: 'var(--text-light)', // White for text on dark backgrounds
      muted: 'var(--muted-foreground)', // Dynamic muted text
    },
    
    // Light, welcoming backgrounds
    background: {
      primary: 'var(--bg-primary)', // Dynamic primary bg
      secondary: 'var(--bg-secondary)', // Dynamic secondary bg
      tertiary: 'var(--bg-tertiary)', // Dynamic tertiary bg
      card: 'var(--bg-card)', // Dynamic card bg
      overlay: 'rgba(255, 255, 255, 0.95)', // Semi-transparent white
    },
    
    // Orange gradient backgrounds
    gradients: {
      primary: 'linear-gradient(135deg, #ff8c42 0%, #ffb366 100%)',
      secondary: 'linear-gradient(135deg, #ffb366 0%, #ffd93d 100%)',
      warm: 'linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%)',
    },
    
    // Borders and dividers
    border: {
      light: 'var(--border-light)',
      medium: 'var(--border-medium)',
      dark: 'var(--border-dark)',
      orange: '#ff8c42',
    },
    
    // Status colors
    success: '#28a745',
    warning: '#ffc107',
    error: '#dc3545',
    info: '#17a2b8',
    
    // Interactive states
    hover: {
      primary: '#ff7a2e',
      secondary: '#ffa366',
      light: '#f8f9fa',
    },
    
    // Shadows with warm tones
    shadow: {
      light: '0 2px 8px rgba(255, 140, 66, 0.1)',
      medium: '0 4px 16px rgba(255, 140, 66, 0.15)',
      heavy: '0 8px 32px rgba(255, 140, 66, 0.2)',
    },
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '3rem',
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '50%',
  },
  shadows: {
    light: '0 2px 8px rgba(255, 140, 66, 0.1)',
    medium: '0 4px 16px rgba(255, 140, 66, 0.15)',
    heavy: '0 8px 32px rgba(255, 140, 66, 0.2)',
  },
  transitions: {
    fast: '0.1s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
    desktop: '1200px',
  },
};
